import { formatter, request } from '@/utils/request';

export namespace VatType {
  export const Path = {
    Query: '/expenseapi/vatType/query',
    Search: '/expenseapi/vatType/search',
    AjaxSearch: '/expenseapi/vatType/ajaxSearch',
    Get: '/expenseapi/vatType/get',
    Post: '/expenseapi/vatType/post',
    Delete: '/expenseapi/vatType/delete',
    GetByValue: '/expenseapi/vatType/getVatTypeByValue',
    GetForBd: '/expenseapi/vatType/getForBd',
    GetVAT13: '/expenseapi/vatType/getVAT13',
    GetVAT0: '/expenseapi/vatType/getVAT0',
  };

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.QueryForVatTypeData>>(Path.Query, formatter(options),);
  }

  export async function ajaxSearch(body: API.VatTypeFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.VatType[]>>(Path.AjaxSearch, formatter(options));
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.VatType>>(Path.Get, formatter(options));
  }

  //对应原 getVatTypes
  export async function search(param: API.VatTypeFilter) {
    const options = {
      method: 'POST',
      body: {
        ...param
      },
    };
    return request<API.ResponseResult<API.VatType[]>>(Path.Search, formatter(options));
  }

  export async function post(body: API.VatType) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any>>(Path.Post, formatter(options));
  }

  export async function del(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<any>>(Path.Delete, formatter(options));
  }

  export async function getByValue(value: number) {
    const options = {
      method: 'GET',
      body: {
        value: value,
      },
    };
    return request<API.ResponseResult<API.VatType>>(Path.GetByValue, formatter(options));
  }

  export async function getForBd() {
    const options = {
      method: 'GET',
      body: {
      },
    };
    return request<API.ResponseResult<API.VatType[]>>(Path.GetForBd, formatter(options));
  }

  export async function getVAT13() {
    const options = {
      method: 'GET',
      body: {
      },
    };
    return request<API.ResponseResult<API.VatType>>(Path.GetVAT13, formatter(options));
  }

  export async function getVAT0() {
    const options = {
      method: 'GET',
      body: {
      },
    };
    return request<API.ResponseResult<API.VatType>>(Path.GetVAT0, formatter(options));
  }
}
